const KEY = 'electroz.auth';

export interface AuthTokens {
  accessToken?: string;
  refreshToken?: string;
}

/** Login tokens kept in localStorage. */
export const tokens = {
  get(): AuthTokens {
    try {
      return JSON.parse(localStorage.getItem(KEY) ?? 'null') || {};
    } catch {
      return {};
    }
  },
  set(t: AuthTokens) {
    localStorage.setItem(KEY, JSON.stringify(t));
  },
  clear() {
    localStorage.removeItem(KEY);
  },
};
